<div class="margin-top-xlarge">
  <h3 class="core-title" [ngClass]="{'margin-bottom-sm': selectedStandardSet.standardDescription}">
    Core Concepts
  </h3>
  <span *ngIf="selectedStandardSet.standardDescription" class="standard-subtitle">
    Practice and instruction for {{ selectedStandard.standardName }}
  </span>
  <app-skills [skills]="skills"></app-skills>
  <app-instruction *ngIf="hasSavvas" [standardSetType]="standardSetType" [selectedStandard]="selectedStandard"
    [skillIds]="getSkillIds()"></app-instruction>
  <app-engagement [skills]="skills"></app-engagement>
  <app-targeted-practice *ngIf="hasFreckle" [skills]="skills" [standard]="selectedStandard"></app-targeted-practice>
</div>
